import {HorizontalPositionOfColorCreelPosition} from '@domain/textile-data/color-set/horizontal-position-of-color-creel-position';
import {HorizontalPositionOfGroupCreelPosition} from '@domain/textile-data/colored-yarn-set/horizontal-position-of-group-creel-position';
import {HorizontalPositionOfCreelPosition} from '@domain/textile-data/creel/horizontal-position-of-creel-position';
import {HorizontalPositionOfYarnTypeCreelPosition} from '@domain/textile-data/yarn-set/horizontal-position-of-yarn-type-creel-position';
import {findIndex, isEqual, reduce} from 'lodash-es';

export class CreelPositionsHelper {
  public getPositionOfMaterialTypeCreelInList(materialTypeCreel: HorizontalPositionOfCreelPosition, list: HorizontalPositionOfCreelPosition[]): number {
    const uniqueListOfMaterialTypeCreelPositions = this.getUniqueListOfMaterialTypeCreelPositions(list);

    return findIndex(uniqueListOfMaterialTypeCreelPositions, (materialTypeCreelPosition: HorizontalPositionOfCreelPosition) => {
      let result = false;

      if (materialTypeCreel instanceof HorizontalPositionOfColorCreelPosition && materialTypeCreelPosition instanceof HorizontalPositionOfColorCreelPosition) {
        result = isEqual(materialTypeCreel.color.id, materialTypeCreelPosition.color.id);
      } else if (materialTypeCreel instanceof HorizontalPositionOfYarnTypeCreelPosition && materialTypeCreelPosition instanceof HorizontalPositionOfYarnTypeCreelPosition) {
        result = isEqual(materialTypeCreel.yarnType.id, materialTypeCreelPosition.yarnType.id);
      }

      return result;
    });
  }

  private getUniqueListOfMaterialTypeCreelPositions(
    groupAndMaterialTypeCreelPositions: HorizontalPositionOfCreelPosition[],
    materialTypeCreelPositionsCache: Record<string, boolean> = {}
  ): HorizontalPositionOfCreelPosition[] {
    return reduce(
      groupAndMaterialTypeCreelPositions,
      (uniqueGroupAndMaterialTypeCreelPositions: HorizontalPositionOfCreelPosition[], groupOrMaterialTypeCreel: HorizontalPositionOfCreelPosition) => {
        if (groupOrMaterialTypeCreel instanceof HorizontalPositionOfGroupCreelPosition) {
          uniqueGroupAndMaterialTypeCreelPositions.push(...this.getUniqueListOfMaterialTypeCreelPositions(groupOrMaterialTypeCreel.group, materialTypeCreelPositionsCache));
        } else if (groupOrMaterialTypeCreel instanceof HorizontalPositionOfColorCreelPosition && !materialTypeCreelPositionsCache[groupOrMaterialTypeCreel.color.id]) {
          materialTypeCreelPositionsCache[groupOrMaterialTypeCreel.color.id] = true;
          uniqueGroupAndMaterialTypeCreelPositions.push(groupOrMaterialTypeCreel);
        } else if (groupOrMaterialTypeCreel instanceof HorizontalPositionOfYarnTypeCreelPosition && !materialTypeCreelPositionsCache[groupOrMaterialTypeCreel.yarnType.id]) {
          materialTypeCreelPositionsCache[groupOrMaterialTypeCreel.yarnType.id] = true;
          uniqueGroupAndMaterialTypeCreelPositions.push(groupOrMaterialTypeCreel);
        }

        return uniqueGroupAndMaterialTypeCreelPositions;
      },
      []
    );
  }
}
